import { FRAUD_MODE_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useFraudModeListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${FRAUD_MODE_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
